// extracted by mini-css-extract-plugin
module.exports = {"hero":"index-module--hero--nkUhx"};